import React, { useState, useEffect } from 'react';
import { useApi } from '../../hooks/useApi';
import * as PropTypes from 'prop-types';
import DropdownMenu from './index';
import dropdownStyles from './DropdownMenu.module.css';
import commonStrings from '../../resources/commonStrings';
import styles from '../Reports/RecoveryGoalSettingReport/RecoveryGoalSettingReport.module.css';

const propTypes = {
  ariaLabel: PropTypes.string,
  containingTab: PropTypes.string.isRequired,
  dataFn: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  identifier: PropTypes.string.isRequired,
  sessionToken: PropTypes.shape({ headers: PropTypes.shape({ Authorization: PropTypes.string.isRequired }) })
    .isRequired,
  setStateFn: PropTypes.func,
  shouldExecuteFn: PropTypes.func,
  URLConfig: PropTypes.shape({
    url: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    params: PropTypes.shape(),
    data: PropTypes.shape(),
  }).isRequired,
};

function DropdownDataMenu({
  ariaLabel,
  containingTab,
  dataFn,
  disabled,
  identifier,
  URLConfig,
  setStateFn,
  shouldExecuteFn,
  sessionToken,
  title,
}) {
  const loadingState = 'loading';
  const errorState = 'error';

  const [dropdownSelectionState, setDropdownSelectionState] = useState({
    isExpanded: false,
    value: loadingState,
    previousValue: loadingState,
  });
  const [selectionItems, setSelectionItems] = useState([]);
  const shouldExecute = shouldExecuteFn ? shouldExecuteFn(sessionToken, URLConfig) : true;

  const [{ data, isLoading, isError }] = useApi({ ...sessionToken, ...URLConfig }, null, shouldExecute);

  useEffect(() => {
    if (isLoading) {
      setDropdownSelectionState({
        isExpanded: false,
        value: loadingState,
        previousValue: loadingState,
      });
      setSelectionItems([
        {
          displayText: commonStrings.recoveryGoalSettingReport.dropDownDataMenu.loadingIndicator,
          value: loadingState,
        },
      ]);
    } else if (isError) {
      setDropdownSelectionState({
        isExpanded: false,
        value: errorState,
        previousValue: errorState,
      });
      setSelectionItems([
        {
          displayText: commonStrings.recoveryGoalSettingReport.dropDownDataMenu.errorIndicator,
          value: errorState,
        },
      ]);
    } else {
      setDropdownSelectionState({
        isExpanded: false,
        value: 'null',
        previousValue: 'null',
      });
      setSelectionItems(dataFn(data));
    }
  }, [isLoading, isError]);

  const onDropdownSelection = (isExpanded, value) => {
    setDropdownSelectionState({
      isExpanded: isExpanded,
      value: value,
      previousValue: dropdownSelectionState.value,
    });
    if (setStateFn && value !== dropdownSelectionState.value) {
      const selectionItem = selectionItems.find((item) => item.value === value);
      setStateFn(selectionItem);
    }
  };

  const handleDropdownExpansion = (isExpanded) => {
    setDropdownSelectionState({
      isExpanded: isExpanded,
      value: dropdownSelectionState.value,
      previousValue: dropdownSelectionState.previousValue,
    });
  };

  return (
    <DropdownMenu
      containingTab={containingTab}
      identifier={identifier}
      selectionItems={selectionItems}
      isExpanded={!disabled && dropdownSelectionState.isExpanded}
      ariaLabel={ariaLabel}
      value={dropdownSelectionState.value}
      previousValue={dropdownSelectionState.previousValue}
      onSortSelection={onDropdownSelection}
      sortExpandStateFn={handleDropdownExpansion}
      classes={`${dropdownStyles['container']} ${styles['dropdown-options']} ${styles['container-width']}`}
    />
  );
}

DropdownDataMenu.propTypes = propTypes;
DropdownDataMenu.defaultProps = {
  URLConfig: {},
};
export default DropdownDataMenu;
